export const ERROR_CODES = {
  PLATFORM: 'PLATFORM_ERROR',
  VALIDATION: 'VALIDATION_ERROR',
  NEXT_PAGE: 'NEXT_PAGE_ERROR',
  API_ROUTE: 'API_ROUTE_ERROR',
  AXIOS: 'AXIOS_ERROR',
} as const

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES]
